import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShopIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shop"}/>
}
